<script lang="typescript">
    export let json

    function syntaxHighlight(json) {
        if (!json) return ""
        json = JSON.stringify(json, undefined, 4)
        json = json.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
        return json.replace(
            /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
            function (match) {
                var cls = "number"
                if (/^"/.test(match)) {
                    if (/:$/.test(match)) {
                        cls = "key"
                    } else {
                        cls = "string"
                    }
                } else if (/true|false/.test(match)) {
                    cls = "boolean"
                } else if (/null/.test(match)) {
                    cls = "null"
                }
                return '<span class="' + cls + '">' + match + "</span>"
            }
        )
    }
</script>

{#if json}
    <div class="background">
        <div class="content">
            <div style="display:flex">
                {#each json as j, index}
                    <div style="padding-left: 10px; padding-right: 30px; border-right: 1px solid #999; width: 33%;">
                        <h4>
                            {#if index == 0}Excel{/if}
                            {#if index == 1}Online{/if}
                            {#if index == 2}Diff{/if}
                        </h4>
                        <div style="white-space: pre-wrap">
                            {@html syntaxHighlight(j)}
                        </div>
                    </div>
                {/each}
            </div>
        </div>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
            class="close"
            on:click="{() => {
                json = null
            }}"
        >
            X
        </div>
    </div>
{/if}

<style lang="less">
    .background {
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        position: fixed;
        background-color: #00000070;
        z-index: 100;
    }

    div.close {
        color: white;
        position: fixed;
        right: 20px;
        top: 20px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        border: 1px solid white;
        border-radius: 5px;
        text-align: center;
        background: black;
        cursor: pointer;
    }

    .background div.content {
        position: fixed;
        top: 30px;
        left: 30px;
        bottom: 30px;
        right: 30px;
        margin: auto;
        color: black;
        background-color: #eee;
        padding: 20px;
        overflow: auto;
        line-height: 1.2em;
    }

    :global(.string) {
        color: orangered;
    }
    :global(.number) {
        color: blue;
    }
    :global(.boolean) {
        color: magenta;
    }
    :global(.null) {
        color: grey;
    }
    :global(.key) {
        color: black;
    }
</style>
